import { Container } from "../container-view/models/container";
import { ContainerItem } from "../container-view/models/container-item";
import { ContainerType } from "../container-view/models/container-type-enum";
import { MaterialType, CarrierType } from "../carrier/carrier-enum";
import { Material } from "../container-view/models/material";
import { ReactionSet } from "../container-view/models/reaction-set";

export class ContainerUtility {

    getStateAsString(container: any): string {
        let carrier = container;
        if (carrier !== undefined && carrier !== null && carrier.state !== undefined && carrier.state !== null) {
            if (carrier.state.toString() == "COMPLETE") {
                return 'SC';
            }
            else if (carrier.state.toString() == "WORK_IN_PROGRESS") {
                return 'WIP';
            }
            else if (carrier.state.toString() == "LAB_PROCESSING") {
                return 'LP';
            }
        }
        else {
            return "";
        }

    }

    getCarrierTypeAsString(container: any): string {

        if (container.containerType != null && container.containerType == ContainerType.CARRIER) {
            let carrier = container;
            if (carrier !== undefined && carrier !== null && carrier.carrierType !== undefined && carrier.carrierType !== null) {
                if (carrier.carrierType.toString() == "TUBE_CARRIER") {
                    return 'LightRun Tubes';
                }
                //For Light run plates material type is null
                else if (carrier.materialType == null && carrier.carrierType.toString() == "PLATE_CARRIER") {
                    return 'LightRun Plates';
                }
                else if (carrier.carrierType.toString() == "MIX2SEQ") {
                    return 'mix2seq';
                }
                else if (carrier.carrierType.toString() == "TUBE_RACK") {
                    return 'Primer Tube Rack';
                }
                //For primer plates material type is not null
                else if (carrier.materialType != null && carrier.carrierType.toString() == "PLATE_CARRIER") {
                    return "Primer Plate Carrier"
                }
                else if (carrier.carrierType == CarrierType.SR_TUBE_CARRIER || carrier.carrierType == CarrierType.PURIFIED_DNA) {
                    return "SR Tube";
                }
                else if (carrier.carrierType == CarrierType.UNPURIFIED_PCR) {
                    return "Unpurified DNA";
                }
                else if (carrier.carrierType == CarrierType.HAMILTON_CARRIER) {
                    return "HAMILTON CARRIER";
                }
            }
            else {
                return "";
            }
        }
        else {
            return "";
        }
    }

    getCarrierItemBarcode(i: number, j: number, item: Container, isCarrier: boolean): string {
        let selectedContainer: Container = item;
        if (selectedContainer === null) {
            return null;
        }

        let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedContainer, i, j);

        if (isCarrier) {
            if (currentItem !== null && currentItem.containerItemAware != null) {
                let material = currentItem.containerItemAware as Material;
                if (!material.type || material.type == MaterialType.Sample || material.type == MaterialType.QCSample || material.type == MaterialType.Primer) return material.barcode;
            }
        }
        else {
            if (currentItem !== null) {
                if (currentItem.displayBarcode != null) {
                    return currentItem.displayBarcode;
                } else if (currentItem.containerItemAware != null) {
                    let reactionSet = currentItem.containerItemAware as ReactionSet;
                    if (reactionSet.reactionSetItems !== null) {
                        for (var index = 0; index < reactionSet.reactionSetItems.length; index++) {
                            let material = reactionSet.reactionSetItems[index];
                            if (!material.type || material.type == MaterialType.Sample || material.type == MaterialType.QCSample)
                                return material.barcode;
                        }
                    } else if (reactionSet.materialType == "QCSample" && reactionSet.sampleName == "Eurofins_QC") {
                        return reactionSet.sampleBarcode;
                    }
                }
            }
        }
        return "";
    }

    getCarrierItemForIndex(selectedContainer: Container, i: number, j: number): ContainerItem {
        if (selectedContainer.containerItems != null)
            for (var y = 0; y < selectedContainer.containerItems.length; y++) {
                let currentItem: ContainerItem = selectedContainer.containerItems[y];

                if (currentItem.positionCol == j + 1 && currentItem.positionRow == i + 1) {
                    return currentItem;
                }
            }
        return null;
    }
}